import Vue from 'vue';
import Vuex from 'vuex';
import persisted from 'vuex-persistedstate';
import {vuexfireMutations} from 'vuexfire'

import booking from './modules/booking';
import carrier from './modules/carrier';
import contact from './modules/contact';
import device from './modules/device';
import faqs from './modules/faqs';
import globals from './modules/globals';
import loqate from './modules/loqate';
import navigation from './modules/navigation';
import payments from './modules/payments';
import order from './modules/order';
import scan from './modules/scan';

Vue.use(Vuex);

export const store = new Vuex.Store({
    plugins: [
        persisted({
            paths: [
                'booking',
                'carrier',
                'device'
            ]
        })
    ],
    state: {},
    modules: {
        booking,
        carrier,
        contact,
        device,
        faqs,
        globals,
        loqate,
        navigation,
        payments,
        order,
        scan
    },
    mutations: vuexfireMutations
});

export default store;